import { TvChannelProgram } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { convertMsToSeconds } from '@/shared/lib/date';

import { ChannelCardProgramData } from '../../types';
import { I18n } from '../../hooks/useI18n';

import { transformTvProgramTypeNameMap } from './transformTvProgramTypeNameMap';

export const getChannelCardProgramData = (
    program: TvChannelProgram | null | undefined,
    i18n: I18n
): ChannelCardProgramData => {
    if (!program) {
        return {};
    }

    return {
        programName: program.title,
        programType: transformTvProgramTypeNameMap(program.typeName, i18n),
        currentTime: convertMsToSeconds(program.elapsed(Date.now())),
        totalTime: convertMsToSeconds(program.duration),
    };
};
